import { Inbox } from "@novu/react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { NotificationIcon } from "../../Icons/Notification";
import "./style.scss";

export function NotificationCenter() {
  const navigate = useNavigate();
  const userInfo = useSelector((state: any) => state.user.user);

  if (!userInfo?.id) return null; // Prevent rendering without a subscriber

  return (
    <Inbox
      applicationIdentifier="UJU0SfG6nHEV"
      routerPush={(path: string) => navigate(path)}
      renderBell={(num) => (
        <div className="header-notification">
          <NotificationIcon />
          {<span>{num > 0 ? num : 0}</span>}
        </div>
      )}
      subscriber={userInfo.id?.toString()}
      placement="bottom-start"
    />
  );
}
